module.exports = __webpack_public_path__ + "img/Sophos-Intercept- X.2d650d9.svg";